/* =========================================================
   David Halfon — custom-menu.js
   Desktop mega menu: apertura al passaggio del mouse.
   Mobile e tastiera: comportamento nativo Dawn invariato.
   ========================================================= */

(function () {
  "use strict";

  var DESKTOP_POINTER = "(min-width: 990px) and (hover: hover) and (pointer: fine)";
  var MENU_SELECTOR =
    "header.header .header__inline-menu header-menu > details.mega-menu";
  var CLOSE_DELAY = 180;

  var desktopPointer = window.matchMedia(DESKTOP_POINTER);
  var initializedMenus = new WeakSet();
  var activeDetails = null;
  var closeTimer = null;

  function getSummary(details) {
    return details ? details.querySelector(":scope > summary") : null;
  }

  function getHeaderMenu(details) {
    return details ? details.closest("header-menu") : null;
  }

  function updateExpanded(details) {
    var summary = getSummary(details);
    if (summary) summary.setAttribute("aria-expanded", details.open ? "true" : "false");
  }

  function clearCloseTimer() {
    if (!closeTimer) return;
    window.clearTimeout(closeTimer);
    closeTimer = null;
  }

  function closeMenu(details) {
    if (!details) return;

    var headerMenu = getHeaderMenu(details);

    if (headerMenu && typeof headerMenu.close === "function") {
      headerMenu.close();
    } else {
      details.removeAttribute("open");
      updateExpanded(details);
    }

    details.classList.remove("dh-menu-hover-open");
    details.removeAttribute("data-dh-hover-open");

    if (activeDetails === details) activeDetails = null;
    if (!activeDetails) document.documentElement.classList.remove("dh-menu-is-open");
  }

  function closeOtherMenus(currentDetails) {
    document.querySelectorAll(MENU_SELECTOR).forEach(function (details) {
      if (details !== currentDetails && details.open) closeMenu(details);
    });
  }

  function openMenu(details) {
    if (!details || !desktopPointer.matches) return;

    clearCloseTimer();
    closeOtherMenus(details);

    if (!details.open) details.setAttribute("open", "");

    details.setAttribute("data-dh-hover-open", "true");
    details.classList.add("dh-menu-hover-open");
    updateExpanded(details);

    activeDetails = details;
    document.documentElement.classList.add("dh-menu-is-open");
  }

  function scheduleClose(details) {
    if (!details || !desktopPointer.matches) return;

    clearCloseTimer();
    closeTimer = window.setTimeout(function () {
      closeTimer = null;

      if (details.matches(":hover") || details.contains(document.activeElement)) return;
      closeMenu(details);
    }, CLOSE_DELAY);
  }

  function bindMenu(details) {
    if (!details || initializedMenus.has(details)) return;

    var headerMenu = getHeaderMenu(details);
    var summary = getSummary(details);
    var hoverArea = headerMenu || details;

    if (!summary) return;

    initializedMenus.add(details);

    hoverArea.addEventListener("pointerenter", function (event) {
      if (event.pointerType === "touch") return;
      openMenu(details);
    });

    hoverArea.addEventListener("pointerleave", function (event) {
      if (event.pointerType === "touch") return;
      scheduleClose(details);
    });

    /* Il pointerenter ha già aperto il menu. Evita che il click del mouse
       sul summary lo richiuda immediatamente. Il click da tastiera (detail 0)
       continua invece a essere gestito normalmente da Dawn. */
    summary.addEventListener("click", function (event) {
      if (
        desktopPointer.matches &&
        event.detail > 0 &&
        details.getAttribute("data-dh-hover-open") === "true"
      ) {
        event.preventDefault();
        openMenu(details);
      }
    });

    details.addEventListener("toggle", function () {
      updateExpanded(details);

      if (!details.open) {
        details.classList.remove("dh-menu-hover-open");
        details.removeAttribute("data-dh-hover-open");
        if (activeDetails === details) activeDetails = null;
        if (!activeDetails) document.documentElement.classList.remove("dh-menu-is-open");
      }
    });
  }

  function initializeMenus(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(MENU_SELECTOR).forEach(bindMenu);
  }

  function closeAllHoverMenus() {
    clearCloseTimer();
    document.querySelectorAll(MENU_SELECTOR).forEach(function (details) {
      if (details.getAttribute("data-dh-hover-open") === "true") closeMenu(details);
    });
  }

  function handleOutsidePointer(event) {
    if (!desktopPointer.matches || !activeDetails) return;
    if (activeDetails.contains(event.target)) return;
    closeMenu(activeDetails);
  }

  function handleEscape(event) {
    if (event.key !== "Escape" || !activeDetails) return;

    var summary = getSummary(activeDetails);
    closeMenu(activeDetails);
    if (summary) summary.focus();
  }

  function initialize() {
    initializeMenus(document);

    document.addEventListener("pointerdown", handleOutsidePointer, true);
    document.addEventListener("keydown", handleEscape);

    document.addEventListener("shopify:section:load", function (event) {
      initializeMenus(event.target);
    });

    window.addEventListener("pageshow", function () {
      initializeMenus(document);
      closeAllHoverMenus();
    });

    if (typeof desktopPointer.addEventListener === "function") {
      desktopPointer.addEventListener("change", closeAllHoverMenus);
    } else if (typeof desktopPointer.addListener === "function") {
      desktopPointer.addListener(closeAllHoverMenus);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
